module.exports = __webpack_public_path__ + "static/media/image.58b695dc.svg";